import { SaleData, MarketValueData } from "./types";
import { formatCurrency, formatNumber, formatPricePerSqFt } from "./formatters";

export const saleTableHeaders = [
    "Parcel",
    "Land Size (sq ft)",
    "Building Size (sq ft)",
    "Land Value",
    "Improvements",
    "Total",
    "Land Value/SF",
    "Total/SF",
];

export const marketValueHeaders = ["Approach", "Land", "Improvements", "Total"];

export const getSaleRowData = (saleData: SaleData): (string | number)[] => [
    saleData.parcelNumber,
    formatNumber(saleData.landSize),
    formatNumber(saleData.buildingSize),
    formatCurrency(saleData.landValue),
    formatCurrency(saleData.improvements),
    formatCurrency(saleData.total),
    formatPricePerSqFt(saleData.landValuePerSqFt),
    formatPricePerSqFt(saleData.totalPerSqFt),
];

export const getMarketValueRows = (marketValueData: MarketValueData): (string | number)[][] => [
    [
        "Replacement Cost (N/A - under improved)",
        formatCurrency(marketValueData.replacementCost.land),
        formatCurrency(marketValueData.replacementCost.improvements),
        formatCurrency(marketValueData.replacementCost.total),
    ],
    [
        "Fee Simple Income Approach",
        formatCurrency(marketValueData.feeSimpleIncomeApproach.land),
        formatCurrency(marketValueData.feeSimpleIncomeApproach.improvements),
        formatCurrency(marketValueData.feeSimpleIncomeApproach.total),
    ],
    [
        "Comparable Sales Approach",
        formatCurrency(marketValueData.comparableSalesApproach.land),
        formatCurrency(marketValueData.comparableSalesApproach.improvements),
        formatCurrency(marketValueData.comparableSalesApproach.total),
    ],
    [
        "Indication of Fair Market Value",
        formatCurrency(marketValueData.indicationOfFairMarketValue.land),
        formatCurrency(marketValueData.indicationOfFairMarketValue.improvements),
        formatCurrency(marketValueData.indicationOfFairMarketValue.total),
    ],
];
